import { Box, MenuItem, Select, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { UseSortByProps } from 'react-instantsearch';

import { useSearchSortBy } from './SearchSortBy.hook';

export const SearchSortBy = ({ items }: UseSortByProps) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'SearchDialog' });

  const { options, value, handleChange } = useSearchSortBy({
    items,
  });

  return (
    <Box
      sx={{
        paddingBottom: 4,
      }}
    >
      <Typography variant="subtitle1">{t('sortBy.title')}</Typography>
      <Select
        value={value}
        onChange={handleChange}
        variant="outlined"
        size="small"
        sx={(theme) => ({ width: '50%', backgroundColor: theme.palette.common.white })}
        slotProps={{ input: {} }}
        MenuProps={{ disableScrollLock: true }}
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value} onChange={handleChange}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
};
